import { callIgnoreError } from '@/common/utilities';

export class TeardownManager {
  protected cleanups: VoidFunction[] = [];
  protected namedCleanups: Record<string, VoidFunction> = {};

  add(name: string, fn: VoidFunction): TeardownManager;
  add(fn: VoidFunction): TeardownManager;
  add(nameOrFn: VoidFunction | string, fn?: VoidFunction) {
    if (typeof nameOrFn === 'function') {
      this.cleanups.push(nameOrFn);
      return this;
    }
    fn && (this.namedCleanups[nameOrFn] = fn);
    return this;
  }

  tearOne(name: string) {
    callIgnoreError(this.namedCleanups[name]);
    delete this.namedCleanups[name];
  }

  teardown() {
    [...this.cleanups, ...Object.values(this.namedCleanups)].forEach(callIgnoreError);
    this.namedCleanups = {};
    this.cleanups = [];
  }
}
